export type SocialMediaCampaignStatus = "DRAFT" | "PUBLISHED" | "ARCHIVED";

export type SocialMediaCreativeFormatKey =
  | "INSTAGRAM_SQUARE"
  | "INSTAGRAM_STORY"
  | "FACEBOOK_POST"
  | "WHATSAPP_STATUS"
  | "LINKEDIN_POST";

export type SocialMediaCreativeTextAlign = "left" | "center";

export type SocialMediaCreativeSectionKey = "headline" | "body" | "cta" | "background" | "logo";

export type SocialMediaCreativeTextLayerKey = "headline" | "body" | "cta";

export interface SocialMediaCreativePoint {
  x: number;
  y: number;
}

export interface SocialMediaCreativeSectionVisibility {
  headline: boolean;
  body: boolean;
  cta: boolean;
  background: boolean;
  logo: boolean;
}

export interface SocialMediaCreativeLayout {
  headline: SocialMediaCreativePoint;
  body: SocialMediaCreativePoint;
  cta: SocialMediaCreativePoint;
}

export interface SocialMediaCreativeLayerLocks {
  headline: boolean;
  body: boolean;
  cta: boolean;
}

export interface SocialMediaCreativeLayerStyle {
  fontScale: number;
  fontWeight: number;
  italic: boolean;
  uppercase: boolean;
  color?: string;
  lineHeight: number;
  letterSpacing: number;
}

export interface SocialMediaCreativeLayerStyles {
  headline: SocialMediaCreativeLayerStyle;
  body: SocialMediaCreativeLayerStyle;
  cta: SocialMediaCreativeLayerStyle;
}

export interface SocialMediaCreativeConfig {
  formatKey: SocialMediaCreativeFormatKey;
  fontFamily: string;
  backgroundColor: string;
  accentColor: string;
  textColor: string;
  textAlign: SocialMediaCreativeTextAlign;
  ctaText: string;
  backgroundImageUrl?: string | null;
  logoImageUrl?: string | null;
  sectionVisibility?: SocialMediaCreativeSectionVisibility;
  contentLayout?: SocialMediaCreativeLayout;
  layerLocks?: SocialMediaCreativeLayerLocks;
  layerStyles?: SocialMediaCreativeLayerStyles;
}

export interface SocialMediaTemplateParams {
  kiosk_name: string;
  kiosk_meals_provided: number;
  kiosk_amount_raised: string;
  global_food_bars: number;
}

export interface SocialMediaCampaignMessage {
  id: number;
  title: string;
  contentHtml: string;
  plainContent: string;
  templateContent?: string | null;
  resolvedContent?: string | null;
  templateParams?: SocialMediaTemplateParams | null;
  imageUrl?: string | null;
  formatKey?: SocialMediaCreativeFormatKey | null;
  creativeConfig?: SocialMediaCreativeConfig | null;
  status: SocialMediaCampaignStatus;
  createdByEmail?: string | null;
  publishedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const SOCIAL_MEDIA_TEMPLATE_PARAMS: Array<{ key: keyof SocialMediaTemplateParams; label: string; description: string }> = [
  { key: "kiosk_name", label: "Kiosk Name", description: "The display name of this kiosk" },
  { key: "kiosk_meals_provided", label: "Kiosk Meals Provided", description: "Total meals funded through this kiosk" },
  { key: "kiosk_amount_raised", label: "Kiosk Amount Raised ($)", description: "Total USD raised through this kiosk" },
  { key: "global_food_bars", label: "Global Food Bars", description: "Total food bars donated globally across all campaigns" },
];
